/**
 * FormButtons
 */
import React from 'react';
import { Button } from 'ui-component-library/base/Form';
import { Button as StandardButton } from 'ui-component-library/base';
var NextButton = function (_a) {
    var nextId = _a.nextId, isExpanded = _a.isExpanded, id = _a.id;
    return (React.createElement(Button, { type: "submit", name: "submit", "aria-controls": nextId, "aria-expanded": isExpanded, id: id }, "N\u00E4sta"));
};
var PreviousButton = function (_a) {
    var previousIndex = _a.previousIndex, previousId = _a.previousId, isExpanded = _a.isExpanded, id = _a.id, onPrevious = _a.onPrevious;
    return (React.createElement(StandardButton, { type: "button", id: id, "aria-controls": previousId, "aria-expanded": isExpanded, onClick: function () {
            return onPrevious({
                currentStep: previousIndex,
                invalidFields: [],
            });
        } }, "Tillbaka"));
};
export { PreviousButton, NextButton };
